export default {"src":"/_next/static/media/gluten.1c7dd470.svg","height":512,"width":512,"blurWidth":0,"blurHeight":0};